"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Utils_1 = require("../Utils");
var GridSelection_1 = require("../GridSelection");
var GridSelectionHandler_1 = require("../GridSelectionHandler");
var TreeGridSelectionUtils_1 = require("./TreeGridSelectionUtils");
/**
 * TreeGridSelection is used to track the selected items in the grid who are
 * hidden because their parent is in a collapsed state. It inherits from
 * GridSelection, which is used to track the visible selections.
 */
var TreeGridSelection = /** @class */ (function (_super) {
    __extends(TreeGridSelection, _super);
    function TreeGridSelection() {
        var _this = _super.call(this) || this;
        _this.hiddenSelection = {
            rowRanges: [],
            colRanges: [],
            cellRanges: []
        };
        return _this;
    }
    TreeGridSelection.prototype.clearSelection = function () {
        _super.prototype.clearSelection.call(this);
        this.clearHiddenSelection();
    };
    TreeGridSelection.prototype.initializeSelection = function (selectionData) {
        this.clearHiddenSelection();
        _super.prototype.initializeSelection.call(this, selectionData);
    };
    TreeGridSelection.prototype.initializeHiddenSelection = function (hiddenSelectionData) {
        this.hiddenSelection = hiddenSelectionData;
    };
    TreeGridSelection.prototype.getHiddenSelection = function () {
        return this.hiddenSelection;
    };
    TreeGridSelection.prototype.clearHiddenSelection = function () {
        this.hiddenSelection.rowRanges = [];
        this.hiddenSelection.colRanges = [];
        this.hiddenSelection.cellRanges = [];
    };
    return TreeGridSelection;
}(GridSelection_1.GridSelection));
exports.TreeGridSelection = TreeGridSelection;
/**
 * TreeGridSelectionHandler is used to add persistence for selection of rows whose parent is collapsed.
 */
var TreeGridSelectionHandler = /** @class */ (function (_super) {
    __extends(TreeGridSelectionHandler, _super);
    /**
     * constructor passes a new TreeGridSelection to it's parent class to use instead of GridSelection
     */
    function TreeGridSelectionHandler(component) {
        var _this = _super.call(this, component, new TreeGridSelection()) || this;
        _this.treeGridSelection = _this.gridSelection;
        // force tree selection to only perform selection by rows, not cells or columns
        _super.prototype.setCellPointerEventBehavior.call(_this, GridSelectionHandler_1.CellPointerEventBehavior.SelectRow);
        _super.prototype.setRowPointerEventBehavior.call(_this, GridSelectionHandler_1.RowPointerEventBehavior.SelectRow);
        return _this;
    }
    TreeGridSelectionHandler.prototype.getHiddenSelection = function () {
        return this.generateNewHiddenSelectionData();
    };
    TreeGridSelectionHandler.prototype.initializeHiddenSelection = function (selectionData) {
        this.treeGridSelection.initializeHiddenSelection(selectionData);
    };
    TreeGridSelectionHandler.prototype.setCellPointerEventBehavior = function (cellSelectionBehavior) {
        Utils_1.assert(cellSelectionBehavior === GridSelectionHandler_1.CellPointerEventBehavior.SelectRow, 'TreeGridSelectionHandler can only perform row selection');
    };
    TreeGridSelectionHandler.prototype.setRowPointerEventBehavior = function (rowPointerEventBehavior) {
        Utils_1.assert(rowPointerEventBehavior === GridSelectionHandler_1.RowPointerEventBehavior.SelectRow, 'TreeGridSelectionHandler can only perform row selection');
    };
    /** @returns a new array containing the indexes of all selected domain items, including those that are
     * hidden because they belong to a parent that is in a collapsed state.
     */
    TreeGridSelectionHandler.prototype.getSelectedDomainIndexes = function (convertToDomainIndex) {
        var domainIndexes = [];
        TreeGridSelectionUtils_1.TreeGridSelectionUtils.forEachRowIndexInSelection(this.treeGridSelection.getSelection(), function (index) { return domainIndexes.push(convertToDomainIndex(index)); });
        TreeGridSelectionUtils_1.TreeGridSelectionUtils.forEachRowIndexInSelection(this.treeGridSelection.getHiddenSelection(), function (index) { return domainIndexes.push(index); });
        return domainIndexes;
    };
    TreeGridSelectionHandler.prototype.generateNewState = function () {
        return Utils_1.assign({}, _super.prototype.generateNewState.call(this), { hiddenDomainIndexSelectionData: this.generateNewHiddenSelectionData() });
    };
    TreeGridSelectionHandler.prototype.generateNewHiddenSelectionData = function () {
        var originalSelection = this.treeGridSelection.getHiddenSelection();
        return {
            rowRanges: originalSelection.rowRanges,
            colRanges: originalSelection.colRanges,
            cellRanges: originalSelection.cellRanges
        };
    };
    /**
     * When a row is expanded, any hidden selections are pulled from hiddenSelection, converted to grid-based ranges, and
     * pushed onto the regular selection.
     * When a row is collapsed, any selected children of the row are moved from the regular selection to the hidden selection.
     * @param isExpanded - true if the row is being expanded; false if it's being collapsed
     * @param gridRowIndex - the index of the row in the grid
     * @param numChildren - how many children belong to this row
     * @param convertToDomainIndex - method used to convert grid row indexes to domain indexes.
     */
    TreeGridSelectionHandler.prototype.handleRowExpansion = function (isExpanded, gridRowIndex, numChildren, convertGridRowIndexToDomainIndex) {
        if (numChildren <= 0) {
            return; // nothing to do if there are no children
        }
        var hiddenDomainRanges = this.treeGridSelection.getHiddenSelection().rowRanges;
        var visibleGridRanges = this.treeGridSelection.getSelection().rowRanges;
        var selectionIsChanged = false;
        if (isExpanded) {
            TreeGridSelectionUtils_1.TreeGridSelectionUtils.splitRanges(visibleGridRanges, gridRowIndex, gridRowIndex, numChildren);
            var domainIndex = convertGridRowIndexToDomainIndex(gridRowIndex);
            var domainRangeOfChildren = { begin: domainIndex + 1, end: domainIndex + numChildren };
            selectionIsChanged = TreeGridSelectionUtils_1.TreeGridSelectionUtils.unhideDomainSelections(hiddenDomainRanges, visibleGridRanges, gridRowIndex + 1, domainRangeOfChildren);
        }
        else {
            var extractedRanges = TreeGridSelectionUtils_1.TreeGridSelectionUtils.splitRanges(visibleGridRanges, gridRowIndex, gridRowIndex + numChildren, -numChildren);
            selectionIsChanged = extractedRanges.length > 0;
            extractedRanges.forEach(function (range) {
                hiddenDomainRanges.push({ begin: convertGridRowIndexToDomainIndex(range.begin), end: convertGridRowIndexToDomainIndex(range.end) });
            });
        }
        if (selectionIsChanged) {
            this.updateComponentSelectionState();
        }
    };
    return TreeGridSelectionHandler;
}(GridSelectionHandler_1.GridSelectionHandler));
exports.TreeGridSelectionHandler = TreeGridSelectionHandler;
//# sourceMappingURL=TreeGridSelection.js.map